import { getCookie, getStorage, hasP } from "../../utils/helpers";
import {
  SET_USER_TOKEN,
  REQUEST_VERIFY_TOKEN_SUCCESS,
  REQUEST_VERIFY_TOKEN,
  REQUEST_VERIFY_TOKEN_FAILED,
  VERIFY_USER,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_FAILED,
} from "./types";
import { SET_USER_C, SIGN_OUT } from "../auth/types";

let user = getCookie("user") ? JSON.parse(getCookie("user")) : undefined;

const initialState = {
  userToken: getCookie("user_token") || "",
  userId: getCookie("user_id") || "",
  isAuthenticated: !!getCookie("user_token") ,
  status: getCookie("user") ? JSON.parse(getCookie("user")).status : "",
  email: getCookie("user") ? JSON.parse(getCookie("user")).email : "",
  msisdn: getCookie("user") ? JSON.parse(getCookie("user")).msisdn : "",
  requestingVerifyToken: false,
  verificationCodeRequested: false,
  verifyingUser: false,
  verifiedUser: {},
};
console.log("....");
export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_OUT:
      return {
        ...initialState,
      };
    case SET_USER_TOKEN:
      return {
        ...state,
        userToken: getCookie("user_token") || action.token,
      };
    case SET_USER_C:
      return {
        ...state,
        userToken: action.userToken,
        userId: action.userId,
        isAuthenticated: action.isAuthenticated,
      };
    case REQUEST_VERIFY_TOKEN:
      return {
        ...state,
        requestingVerifyToken: true,
      };
    case REQUEST_VERIFY_TOKEN_SUCCESS:
      return {
        ...state,
        requestingVerifyToken: false,
        verificationCodeRequested: true,
      };
    case REQUEST_VERIFY_TOKEN_FAILED:
      return {
        ...state,
        requestingVerifyToken: false,
      };
    case VERIFY_USER:
      return {
        ...state,
        verifyingUser: true,
      };
    case VERIFY_USER_SUCCESS:
      return {
        ...state,
        verifyingUser: false,
        verifiedUser: action.payload.data,
        status: getStorage("user") ? JSON.parse(getStorage("user")).status : "",
      };
    case VERIFY_USER_FAILED:
      return {
        ...state,
        verifyingUser: false,
      };
    default:
      return state;
  }
};
